// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import TopicButton from "./TopicButton.jsx";
import tippy from "../../common/tippy-control.js";

/**
 * @param {Object}   props
 * @param {function} props.onClickTopic
 * @param {string}   props.selectedTopicUuid
 * @param {Array}    props.topics
 * @return {HTMLElement}
 */
const TopicList = props => {
	// Prepare topic buttons for topic list
	let topicButtons = [];

	for (const topic of props.topics) {
		topicButtons.push(<TopicButton
			onClickTopic={props.onClickTopic}
			selected={props.selectedTopicUuid === topic.uuid}
			topic={topic}
		/>);
	}

	// If there are no topics show a msg
	if (props.topics.length === 0)
		topicButtons = (<div className="no-topics">No topics</div>);

	const ul = <ul className="topics-list js-topics" lang="">{topicButtons}</ul>;

	// Add tooltips that only show if the text is overflowing
	tippy(ul.querySelectorAll("[data-tippy-content]"), {
		overflowingClass:      "topic-text",
		placement:             "left",
		showOnlyIfOverflowing: true
	});

	return ul;
};

export default TopicList;
